import { HiPencil, HiX } from "react-icons/hi";
import { useTranslation } from "@repo/core";

const EditModal = ({
  isUpdating,
  editStrategyName,
  setEditStrategyName,
  handleEditCancel,
  handleEditSave,
}: {
  isUpdating: boolean;
  editStrategyName: string;
  setEditStrategyName: (name: string) => void;
  handleEditCancel: () => void;
  handleEditSave: () => void;
}) => {
  const { tStrategy, tCommon } = useTranslation();

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          handleEditCancel();
        }
      }}
    >
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {tStrategy("editModal.title")}
        </h3>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {tStrategy("editModal.nameLabel")}
          </label>
          <input
            type="text"
            value={editStrategyName}
            onChange={(e) => setEditStrategyName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder={tStrategy("editModal.namePlaceholder")}
            autoFocus
          />
        </div>
        <div className="flex gap-3 justify-end">
          <button
            onClick={handleEditCancel}
            disabled={isUpdating}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiX size={16} />
            {tCommon("cancel")}
          </button>
          <button
            onClick={handleEditSave}
            disabled={isUpdating || !editStrategyName.trim()}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiPencil size={16} />
            {isUpdating ? tStrategy("editModal.saving") : tCommon("save")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditModal;
